export default __webpack_public_path__ + "static/media/eventPageImage.35b44dc1.jpg";